<template>
  <router-link :to="to" event="">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  name: "router-link-nav",
  props: {
    to: String
  },
  computed: {
    route() {
      return this.$route.path;
    }
  },
  watch: {
    to(val) {
      if (val && val.startsWith(this.route)) {
        //console.log("ACTIVE:", val);
      }
    }
  }
};
</script>
